import axios from "axios";
import { superAdminApiUrl } from "../util/Constants";
import type {
  Match,
  PagedResponse,
  Player,
  Tournament,
  TournamentTypeValue,
  User,
} from "../types/domain";

export interface SearchParams {
  q?: string;
  page?: number;
  size?: number;
}

export interface TournamentUpdateDto {
  name?: string;
  organizer?: string;
  setsNeededToWin?: number;
  type?: TournamentTypeValue;
  hidden?: boolean;
}

export const superAdminApi = {
  searchPlayers: async ({ q = "", page = 0, size = 20 }: SearchParams = {}): Promise<PagedResponse<Player>> => {
    const { data } = await axios.get<PagedResponse<Player>>(`${superAdminApiUrl}/players/search`, {
      params: { q, page, size },
    });
    return data;
  },

  searchUsers: async ({ q = "", page = 0, size = 20 }: SearchParams = {}): Promise<PagedResponse<User>> => {
    const { data } = await axios.get<PagedResponse<User>>(`${superAdminApiUrl}/users/search`, {
      params: { q, page, size },
    });
    return data;
  },

  searchTournaments: async ({ q = "", page = 0, size = 20 }: SearchParams = {}): Promise<PagedResponse<Tournament>> => {
    const { data } = await axios.get<PagedResponse<Tournament>>(`${superAdminApiUrl}/tournaments/search`, {
      params: { q, page, size },
    });
    return data;
  },

  searchMatches: async ({ playerId, page = 0, size = 25 }: { playerId: number; page?: number; size?: number }): Promise<PagedResponse<Match>> => {
    const { data } = await axios.get<PagedResponse<Match>>(`${superAdminApiUrl}/matches/search`, {
      params: { playerId, page, size },
    });
    return data;
  },

  updateTournament: async ({ tournamentId, update }: { tournamentId: number; update: TournamentUpdateDto }): Promise<Tournament> => {
    const { data } = await axios.put<Tournament>(`${superAdminApiUrl}/tournaments/${tournamentId}`, update);
    return data;
  },

  setPlayerUserLink: async ({ playerId, userId }: { playerId: number; userId: number | null }): Promise<Player> => {
    const params: Record<string, number> = {};
    if (userId != null) params.userId = userId;
    const { data } = await axios.put<Player>(`${superAdminApiUrl}/players/${playerId}/user-link`, null, { params });
    return data;
  },
};
